module.exports = __webpack_public_path__ + "static/img/11.b1837f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/zh/11.png
// module id = sZvW
// module chunks = 0